var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9945 70H53.0101C62.3653 70 69.9492 62.4051 69.9492 53.0364V16.9685C69.9492 7.59976 62.3653 0.00487518 53.0101 0.00487518H16.9945C7.63929 0.00487518 0.0554123 7.59976 0.0554123 16.9685V53.0364C0.0554123 62.4051 7.63929 70 16.9945 70Z",
    fill: "url(#paint0_linear_1945_23454)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0528 57.2742C59.0528 57.2742 56.3383 52.7441 51.8147 52.7441C47.2911 52.7441 44.8776 57.2742 36.0553 57.2742C16.5272 57.2742 7.24846 41.016 7.17656 40.8885L0 33.1517V15.5046C0 6.94166 6.93162 0 15.4822 0H29.3016L39.5241 10.3814C39.5241 10.3814 39.5241 10.3814 39.5253 10.3826C62.5972 26.0886 55.1324 43.3799 55.1324 43.3799C55.1324 43.3799 61.6924 50.7798 59.0534 57.2742H59.0528Z",
    fill: "url(#paint1_linear_1945_23454)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.578 10.3867C62.6511 26.0933 55.1863 43.3853 55.1863 43.3853C55.1863 43.3853 61.7463 50.7852 59.1073 57.2796C59.1073 57.2796 56.3928 52.7488 51.8686 52.7488C47.3444 52.7488 44.9315 57.2796 36.1098 57.2796C16.5049 57.2796 7.23047 40.8938 7.23047 40.8938C24.8825 52.5426 36.9391 44.292 36.9391 44.292C28.9759 39.66 12.0563 17.5609 12.0563 17.5609C26.8036 30.1231 33.1686 33.4182 33.1686 33.4182C29.3585 30.2763 18.6912 14.9181 18.6912 14.9181C27.2259 23.5665 44.1772 35.6082 44.1772 35.6082C49.0121 22.2973 39.5774 10.3873 39.5774 10.3873L39.578 10.3867Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1945_23454",
    x1: 41.5665,
    y1: -2.27972,
    x2: 28.4012,
    y2: 72.2787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE3D30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1945_23454",
    x1: 35.7085,
    y1: 1.13132,
    x2: 26.0145,
    y2: 56.0277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19E3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23829"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.4cc08177cf93d5baca87ded0005a83d6.svg";
export { ForwardRef as ReactComponent };